import { analyticsEvent } from '@sd-utility/analytics';
import { AnalyticEventType } from 'types/AnalyticsTypes';

const sendAnalyticEvent = ({
  gaCategory = 'UX',
  gaAction = 'Product page',
  gaLabel = '',
  type = undefined,
  sendGoogleAnalytics = true,
  sendSpeedTrap = true,
  data = {},
}: AnalyticEventType = {}) => {
  analyticsEvent({
    category: gaCategory,
    action: gaAction,
    label: gaLabel,
    data: {
      ...data,
    },
    send: {
      googleAnalytics: sendGoogleAnalytics,
      speedtrap: sendSpeedTrap,
    },
    ...(type !== undefined && { type }),
  });
};

export default sendAnalyticEvent;
